export interface CustomLabelProps {
  type?: CustomLabelTypes;
  className?: string;
  size?: Size;
}

export enum CustomLabelTypes {
  'success' = 'success',
  'default' = 'default',
  'gray' = 'gray',
  'primary' = 'primary',
}

export type Size = 'sm' | 'md' | 'lg';
